<!--首页-->
<template>
	<div class="jdqs_content" id="homeCont">
		<div class="ucontent">
			<div class="zh_btn">
				<a
					:href="'http://new.xubei.com/shopList.html?gameid=1494&userId=472474&channel=' + channel"
					class="sw"
					target="_blank"
				></a>
				<a href="https://stsc.steam.xubei.com/" class="qmh"></a>
			</div>
			<div class="steam_game">
				<div class="title">Steam热门推荐</div>
				<div class="steam_list">
					<a
						class="item"
						:href="'http://new.xubei.com/shopList.html?gameid=1494&userId=472474&channel=' + channel"
						target="_blank"
					>
						<div><img src="/static/images/jdqs/tu1.jpg" /></div>
						<div class="tit">绝地求生</div>
						<div class="hao">
							<span>高段号</span>
							<span>鱼塘号</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=2147&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu2.jpg" /></div>
						<div class="tit">武侠乂</div>
						<div class="hao">
							<span>武侠吃鸡</span>
							<span>纯正中国风</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=2149&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu3.jpg" /></div>
						<div class="tit">怪物猎人：世界</div>
						<div class="hao">
							<span>308元豪华版</span>
							<span>鱼塘号</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1518&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu4.jpg" /></div>
						<div class="tit">GTA5</div>
						<div class="hao">
							<span>全解锁</span>
							<span>技能满</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a
						class="item mr"
						:href="'http://new.xubei.com/shopList.html?gameid=1893&channel=' + channel"
						target="_blank"
					>
						<div><img src="/static/images/jdqs/tu5.jpg" /></div>
						<div class="tit">彩虹六号：围攻</div>
						<div class="hao">
							<span>满装备</span>
							<span>所有干员</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>
				</div>
			</div>

			<div class="steam_game">
				<div class="title title2">更多游戏热门推荐</div>
				<div class="steam_list">
					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=302&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu6.jpg" /></div>
						<div class="tit">穿越火线</div>
						<div class="hao"><span>生化爆破全装百V号</span></div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=245&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu7.jpg" /></div>
						<div class="tit">英雄联盟</div>
						<div class="hao">
							<span>满英雄</span>
							<span>稀有皮肤号</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=588&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu8.jpg" /></div>
						<div class="tit">逆战</div>
						<div class="hao">
							<span>创世套</span>
							<span>塔防全装</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=592&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu9.jpg" /></div>
						<div class="tit">QQ飞车</div>
						<div class="hao">
							<span>全29T3</span>
							<span>高改雷诺</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=587&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu10.jpg" /></div>
						<div class="tit">守望先锋</div>
						<div class="hao">
							<span>金武器</span>
							<span>超多皮肤</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1109&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu11.jpg" /></div>
						<div class="tit">王者荣耀</div>
						<div class="hao">
							<span>全英雄</span>
							<span>稀有皮肤</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1822&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu12.jpg" /></div>
						<div class="tit">穿越火线：枪战王者</div>
						<div class="hao"><span>生化爆破全装百V号</span></div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1838&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu13.jpg" /></div>
						<div class="tit">QQ飞车手游</div>
						<div class="hao"><span>主播号至尊V9</span></div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1522&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu14.jpg" /></div>
						<div class="tit">球球大作战</div>
						<div class="hao">
							<span>10W皮</span>
							<span>130秀</span>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1525&channel=' + channel" target="_blank">
						<div><img src="/static/images/jdqs/tu15.jpg" /></div>
						<div class="tit">火影忍者</div>
						<div class="hao"><span>10S战力700万</span></div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>
				</div>
			</div>

			<div class="copyright">
				Copyright © 2015-2016 杭州诸相网络科技有限公司
				<a href="http://www.xubei.com" target="_blank">(www.xubei.com)</a>
				版权所有 浙ICP备15
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'jdwb',
	components: {},
	data: function () {
		return {
			channel: this.$route.query.channel || ''
		};
	},
	mounted() {},
	methods: {}
};

var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?cdea94c5bc45d355e2a3ab8d8664de0d';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.jdqs_content {
	width: 100%;
	height: 100%;
	background: #fff url(/static/images/jdqs/bg.jpg) no-repeat;
	background-size: cover;
	.ucontent {
		width: 1200px;
		margin: 0 auto;
		color: #fff;
		overflow: hidden;
		.zh_btn {
			padding-top: 284px;
			text-align: right;
			.sw {
				display: inline-block;
				background: url(/static/images/jdqs/sw.png) no-repeat;
				width: 389px;
				height: 218px;
			}
			.sw:hover {
				background: url(/static/images/jdqs/sw_hover.png) no-repeat;
			}
			.qmh {
				display: inline-block;
				background: url(/static/images/jdqs/qmh.png) no-repeat;
				width: 232px;
				height: 130px;
				margin-bottom: 42px;
			}
			.qmh:hover {
				background: url(/static/images/jdqs/qmh_hover.png) no-repeat;
			}
		}

		.steam_game {
			.title {
				color: #2d2200;
				font-size: 26px;
				font-weight: bold;
				margin-top: 100px;
				text-align: center;
				margin-bottom: 35px;
			}

			.title2 {
				margin: 4px 0 30px 0;
			}

			.steam_list {
				overflow: hidden;
				.item {
					display: block;
					text-align: center;
					background: #f1f1f1;
					width: 215px;
					float: left;
					margin-right: 25px;
					margin-bottom: 36px;
					// box-shadow: 5px -3px 7px #b9b6b6;

					.tit {
						font-size: 18px;
						color: #2d2200;
						padding: 10px 0;
					}
					.hao {
						margin-bottom: 20px;
						span {
							color: #999999;
							border: 1px solid #999999;
							padding: 1px 5px;
							border-radius: 10px;
							margin: 0 5px;
						}
					}
				}
				.item:hover {
					box-shadow: 1px -1px 22px #736a6a;
				}
				.mr {
					margin-right: 0;
				}

				.sw_btn {
					display: block;
					height: 45px;
					line-height: 45px;
					color: #ff8700;
					background: #e1e1e1 url(/static/images/jdqs/arrow.png) no-repeat 138px center;
				}

				.sw_btn:hover {
					color: #ffa200;
					background: #e1e1e1 url(/static/images/jdqs/arrow_hover.png) no-repeat 138px center;
				}
			}
		}

		.copyright {
			color: #626164;
			text-align: center;
			margin: 32px 0 20px 0;
			a {
				color: #626164;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/jdlh.vue